import { render, staticRenderFns } from "./FooterScheduleSlot.vue?vue&type=template&id=f4413092&"
import script from "./FooterScheduleSlot.vue?vue&type=script&lang=js&"
export * from "./FooterScheduleSlot.vue?vue&type=script&lang=js&"
import style0 from "./FooterScheduleSlot.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VMenu})
